import unique from "array-unique";
const Products = (() => {

    let itemCodes = [];
    let svc = {
        presetProductConditions: (products, params, showAll) => {
            let {activeParent} = params;

            if (!activeParent && !showAll) {
                return products.childCatalogs[0].catalogSlides;
            } else if (!activeParent && showAll) {
                return products.catalogSlides;
            } else {
                return false;
            }
        },
        addPricingToSlides: (slides, pricing) => {
            let productsWithPricing = [];
            slides.forEach((s) => {
                pricing.forEach((p) => {
                    if (s.item.id.unicity === p.lines.items[0].item.id.unicity) {
                        //make a shallow copy of shallow object
                        s.terms = Object.assign({}, p.lines.items[0].terms);
                        //update this
                        s.terms.taxInclusive = false;
                        productsWithPricing.push(s);
                    }
                });

            });
            return productsWithPricing;
        },
        addPricingToCategoryProducts: (catalogs, pricing) => {
            //add pricing to first level of childCatalogs products
            catalogs.forEach((cat) => {
                cat.catalogSlides = svc.addPricingToSlides(cat.catalogSlides, pricing);
                //add pricing to second level of childCatalogs products
                if (cat.childCatalogs.length) {
                    cat.childCatalogs.forEach((cat2) => {
                        cat2.catalogSlides = svc.addPricingToSlides(cat2.catalogSlides, pricing);
                    });
                }
            });
        },
        getItemCodeFromSlides: (slides) => {
            slides.forEach((s) => {
                if (s.item.id.unicity !==undefined) {
                    itemCodes.push(s.item.id.unicity);
                }
            });
        },
        getItemCodeFromCatalogs: (catalogs) => {
            catalogs.forEach((cat) => {
                itemCodes.concat(svc.getItemCodeFromSlides(cat.catalogSlides));
                if (cat.childCatalogs.length) {
                    cat.childCatalogs.forEach((cat2) => {
                        itemCodes.concat(svc.getItemCodeFromSlides(cat2.catalogSlides));
                    });
                }
            });
        },
        setQty: (products, cart) => {

            let updatedProducts = products.map((p) => {

                let match = cart.filter((c) => {
                    return c.item.id.unicity === p.item.id.unicity;
                });

                if (match.length) {
                    p.qty = match[0].qty;

                } else {
                    p.qty = 0;
                }



                return p;
            });
            return updatedProducts;
        }

    };





    return {
        addPricing: (products, pricing) => {
            products.catalogSlides = svc.addPricingToSlides(products.catalogSlides, pricing);
            svc.addPricingToCategoryProducts(products.childCatalogs, pricing);
            return products;

        },
        setQty: (visibleProducts, cart) => {

            return svc.setQty(visibleProducts, cart);

        },
        getItemCodes: products => {
          svc.getItemCodeFromSlides(products.catalogSlides);
          svc.getItemCodeFromCatalogs(products.childCatalogs);
          return unique(itemCodes);
        },
        getVisibleProducts: (products, params,showAll) => {

            let activeCat, {activeParent,activeChild} = params;

            //Some conditions return a preset list of products
            let presetProducts = svc.presetProductConditions(products, params, showAll);

            if (Boolean(presetProducts)) {
                return presetProducts;
            }

            let parentCat = products.childCatalogs.filter((pCat) => {
                return pCat.title === activeParent;
            });

            if (activeChild) {
                let childCat = parentCat[0].childCatalogs.filter((cCat) => {
                    return cCat.title === activeChild;
                });
                activeCat = childCat[0];
            } else {
                activeCat = parentCat[0];
            }



            return activeCat.catalogSlides;

        },
        getCatalog: (products, childCatalog) => {
          let packs = [];
          if(products) {
            packs = products.childCatalogs.find(cat=>cat.alias===childCatalog) || [];
          }
          return packs;
        },

        filterCatalogSlidesByLang: (catalogSlides, lang) => {
          return catalogSlides.filter(p => {
            if(p.content.meta.length && p.content.meta.find(l=>(l.value===lang && l.key==="language"))) {
              return true;
            }
            if(p.content.meta.length && !p.content.meta.find(l=>l.key==="language")) {
              return true;
            }
            if(!p.content.meta.length) {
              return true;
            }
              return false;
          })
        },

        filterBySearchFor: (products, searchFor) => {
          return products.filter(p => {
            if(p.item.id.unicity.search(`${searchFor}`)!==-1) {
              return true;
            }
            if(p.content.name.toLowerCase().search(`${searchFor.toLowerCase()}`)!==-1) {
              return true;
            }
            /*if(p.content.description && p.content.description.toLowerCase().search(`${searchFor.toLowerCase()}`)!==-1) {
              return true;
            }*/
            return false;
          })
        },
        getCategories: (products) => {
          return products.childCatalogs.filter(p => {
            if(p.catalogSlides.length) {
              return true;
            }
            return false;
          })
        },
        getCategoryProducts: (products, categoryName) => {
          return products.filter(p => {
            if(p.alias===categoryName) {
              return true;
            }
            return false;
          })
        },
        getPackType: (customerType, ioShipMethod="") => {
          let packType = (customerType === "PC") ? "PC Packs": "Packs";
          return packType = (ioShipMethod === "miami") ? "Miami "+packType : packType;
        }
      }
})();
export default Products;



// WEBPACK FOOTER //
// ./src/services/products.js